import React from 'react'
import MobileCompleteLayout from '../MobileLayouts/MobileCompleteLayout'
import ComputerCompleteLayout from '../ComputerLayouts/ComputerCompleteLayout'
import { screenSize } from '../../../Common/Common'
import TabletCompleteLayout from '../TabletLayouts/TabletCompleteLayout'

export default function CompleteLayout () {
  const layouts = {
    Mobile: MobileCompleteLayout,
    Computer: ComputerCompleteLayout,
    Tablet: TabletCompleteLayout
  }

  const ResponsiveLayout = layouts[screenSize()]

  return (
    <ResponsiveLayout />
  )
}
